import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { UserSettingsOptions } from '../../../enums/user-settings/user-settings-options';
import { getCarriersPath } from '../../../routes/constants';

import style from './style.module.less';
import messages from './messages';

const showCostSummaryRadioOptions = [
  UserSettingsOptions.quickshipAlwaysShowCostSummary,
  UserSettingsOptions.quickshipShowCostSummaryIfNeeded,
];

const { quickshipAlwaysShowCostSummary: alwaysShow, quickshipNeverShowCostSummary: neverShow } = UserSettingsOptions;

const QuickshipCostSummarySetting = ({ showCostSummaryValue = neverShow.settingValue, setShowCostSummaryValue = noop }) => {
  const toggleValue = useMemo(() => {
    if (showCostSummaryValue === neverShow.settingValue) {
      return alwaysShow.settingValue;
    }
    return neverShow.settingValue;
  }, [showCostSummaryValue]);

  const shouldShowRadios = useMemo(
    () => showCostSummaryRadioOptions.some(({ settingValue }) => settingValue === showCostSummaryValue),
    [showCostSummaryValue],
  );
  const costSummaryLabel = (
    <FormattedMessage
      {...messages.showCostSummary}
      values={{
        a: (chunks) => (
          <Link data-pendo-id='/settings/workflow#set-up-auto-funding' to={getCarriersPath()}>
            {chunks}
          </Link>
        ),
      }}
    />
  );

  return (
    <>
      <div
        key={messages.showCostSummary.description}
        className={classnames(style['section-item'], style['checkbox-row'])}
        onClick={(e) => {
          e.preventDefault();
          setShowCostSummaryValue(toggleValue);
        }}
      >
        <Checkbox
          checked={!(showCostSummaryValue === neverShow.settingValue)}
          label={costSummaryLabel}
          onChange={noop}
          value={showCostSummaryValue}
        />
      </div>
      {shouldShowRadios && (
        <RadioCheckList className={style['cost-summary-section']}>
          {showCostSummaryRadioOptions.map((option) => (
            <RadioCheckListItem
              key={option.settingValue}
              className={style['radio-item']}
              isChecked={option.settingValue === showCostSummaryValue}
              onChecked={() => setShowCostSummaryValue(option.settingValue)}
            >
              <FormattedMessage {...option.messageDescriptor} />
            </RadioCheckListItem>
          ))}
        </RadioCheckList>
      )}
    </>
  );
};

QuickshipCostSummarySetting.propTypes = {
  showCostSummaryValue: PropTypes.string,
  setShowCostSummaryValue: PropTypes.func,
};

export default QuickshipCostSummarySetting;
